module.exports = __webpack_public_path__ + "img/KG.09cc2766.png";